// appLyrics namespace — LyricsEditor.tsx (per-track lyrics editor: TEXT + SYNC,
// real transcript + detected BPM). Keys mirror pl/appLyrics.ts exactly.
// Session 32 (artboards 05a–08e): the transcript state is ONE short sentence over
// the list (`state`); the leave-without-saving and preview windows own their copy.
export const appLyrics = {
  crumb: {
    library: 'Library',
    music: 'Music',
  },
  state: {
    processing: 'Transcription is running.',
    instrumental: 'We detected no words.',
    failed: 'Transcription failed.',
  },
  error: {
    title: 'The lyrics could not be loaded.',
    retry: 'Try again',
  },
  tabs: {
    label: 'Editor mode',
    text: 'Lyrics',
    sync: 'Sync',
  },
  text: {
    heading: 'Song lyrics',
    lineLabel: 'line {n}',
    linePlaceholder: 'Type the words of this line',
    addLine: 'Add line',
    removeLine: 'Remove line {n}',
    seekTo: 'Jump to {time}',
  },
  sync: {
    timeline: 'Timeline',
    selectedWord: 'Selected word',
    move: 'Shift',
    length: 'Length',
    moveLabel: 'Start of "{word}" in seconds',
    lengthLabel: 'Length of "{word}" in seconds',
    earlier: 'Earlier by {step} s',
    later: 'Later by {step} s',
    shorter: 'Shorter by {step} s',
    longer: 'Longer by {step} s',
    snap: 'Snap',
  },
  preview: {
    show: 'Preview',
    play: 'Play',
    close: 'Close',
  },
  leave: {
    title: 'Leave without saving?',
    body: 'Unsaved changes will be lost.',
    stay: 'Stay',
    leave: 'Leave',
  },
  approve: {
    submit: 'Approve lyrics',
    done: 'Lyrics approved.',
    failed: 'Could not approve the lyrics.',
  },
  save: {
    unsaved: 'Unsaved changes',
    saved: 'Saved',
    saving: 'Saving…',
    error: 'Saving failed. Try again.',
    submit: 'Save lyrics',
  },
}
